import styled from 'styled-components';
import { color, container } from '../../../theme';

export const StyledFaqsSection = styled.dl`
  margin: auto;
  max-width: ${container('md')};
  border-bottom: 1px solid ${color('midnight_200')};
  counter-reset: faqs;
`;
